export default "__VITE_ASSET__dLfZ95Im__"